import type { LifecycleTimelineEntry } from '../types/lifecycle';
import { formatDateTime, humanizeEventType, humanizePublicText } from '../utils/lifecycleFormat';

interface EventsTimelineProps {
  events: LifecycleTimelineEntry[];
  title?: string;
}

export function EventsTimeline({ events, title = 'Historie událostí' }: EventsTimelineProps) {
  if (!events || events.length === 0) {
    return (
      <section className="events-timeline events-timeline--empty" aria-label={title}>
        <h4>{title}</h4>
        <p className="events-timeline__empty">Žádné události zatím nejsou zaznamenány.</p>
      </section>
    );
  }

  return (
    <section className="events-timeline" aria-label={title}>
      <h4>{title}</h4>
      <ol className="events-timeline__list">
        {events.map((e, i) => (
          <li key={`${e.event_date}-${e.event_type}-${i}`} className={`events-timeline__item events-timeline__item--${e.event_type}`}>
            <div className="events-timeline__date">{formatDateTime(e.event_date)}</div>
            <div className="events-timeline__type">{humanizeEventType(e.event_type)}</div>
            {timelineSummary(e) && <div className="events-timeline__summary">{timelineSummary(e)}</div>}
          </li>
        ))}
      </ol>
    </section>
  );
}

function timelineSummary(entry: LifecycleTimelineEntry): string {
  const transition = entry.transition;
  if (transition) {
    const from = transition.from_label || transition.from;
    const to = transition.to_label || transition.to;
    if (from && to) return `Z ${from} do ${to}`;
    if (to) return `Do ${to}`;
  }
  return entry.summary ? humanizePublicText(entry.summary) : '';
}
